import React, { useState, useEffect } from "react";
import Table from "../../components/table/Table";
import BackendLayout from "../../layouts/BackendLayout";
import {ButtonBack, RedirectAlert, TextInput} from "../../components";
import InputLabel from "../../components/InputLabel";
import Select2 from "../../components/Select2";
import {
  ButtonTableDelete,
  ButtonAdd,
  ButtonDelete,
  ButtonDPad,
} from "../../components/buttons";
import { useParams } from "react-router";
import {
  useUserSelect,
  useWorkflowSettingPage,
  useWorkFollowData,
} from "../../hooks/MachineWorkFlowHook";
import {
  ArrayUtils,
  SelectUtils,
  errorStatusHandle,
  getInputErrorMessage,
  hasErrorInput,
} from "../../utils";
import { submitWorkFlow } from "../../services/MachineWorkFlowServices";
import { setFlash, getFlash } from "../../utils/storage-utils";
import { PageAlert, PageTitle, SelectInput } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  FormGroup,
  FormGroupInput,
  FormGroupVerticalInput,
  Label,
  RadioInput,
  CheckboxInput,
} from "../../components/form";
import * as routes from "../../constants/routes";
import { useDocumentTitle } from "../../hooks";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { APPROVAL_SETTING } from "../../constants/routes";
import {
  setAlertErrorWorkflowDetails,
  setAlertSuccess,
} from "../../store/actions";
import ButtonEdit from "../../components/buttons/ButtonEdit.js";
import _ from "lodash";
import {APPROVAL_SETTING_DETAIL_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {PREVIOUS_PAGE} from "../../constants/app";

export default function WorkflowDetails() {
  useRedirectPage(APPROVAL_SETTING_DETAIL_PAGE);
  useDocumentTitle("承認設定編集 - 点検王");
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(routes.APPROVAL_SETTING_DETAIL);
  const groupSettings = useSelector((s) => s.app_settings.machine_group);
  const { workFollowId } = useParams();
  const [errors, setErrors] = useState({});
  const { templates, departments, groupTree } = useWorkflowSettingPage();
  const {
    workFollowName,
    tableData,
    frequency,
    workTemplates,
    setWorkFollowName,
    setTableData,
    setFrequency,
    setWorkTemplates,
  } = useWorkFollowData(workFollowId, groupTree);
  const { users } = useUserSelect(workTemplates);

  const [groupsOptions, setGroupOptions] = useState({});
  const [processing, setProcessing] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [buttonState, setButtonState] = useState(false);

  useEffect(() => {
    if (!tableData) {
      return;
    }
    setTableData((prevTableData) => {
      const updatedTableData = prevTableData.map((row) => {
        if (row.type === 2) {
          return row;
        }
        if (_.some(users, { value: row.user_id }) === false) {
          row.user_id = null;
          row.email = "";
        }
        return row;
      });

      return updatedTableData;
    });
  }, [users]);

  useEffect(() => {
    let options = [];
    tableData.forEach((row, idx) => {
      if (row.type === 2) {
        let groupCombine = {
          1: row.group_1,
          2: row.group_2,
          3: row.group_3,
          4: row.group_4,
          5: row.group_5,
        };
        options[idx] = {
          1: groupTree?.getChildrenSelectOptions(true),
          2: groupTree
            ?.findNode(groupCombine[1])
            .getChildrenSelectOptions(true),
          3: groupTree
            ?.findNode(groupCombine[2])
            .getChildrenSelectOptions(true),
          4: groupTree
            ?.findNode(groupCombine[3])
            .getChildrenSelectOptions(true),
          5: groupTree
            ?.findNode(groupCombine[4])
            .getChildrenSelectOptions(true),
        };
      } else {
        options[idx] = [];
      }
    });
    setGroupOptions(options);
  }, [tableData, groupTree]);

  useEffect(() => {
    const message = getFlash("approve-setting");
    dispatch(setAlertSuccess(message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const typeOptions = [
    { value: 2, label: "職位" },
    { value: 1, label: "ユーザー" },
  ];

  const handleChangeRadio = (event) => {
    setFrequency(parseInt(event.target.value));
  };

  // Function help change option select
  function handleChangeInputCheckbox(e, index, fieldName) {
    setTableData((prevTableData) => {
      const updatedTableData = [...prevTableData];
      updatedTableData[index][fieldName] = e.target.checked;
      return updatedTableData;
    });
  }

  // Function help change option select
  function handleSelectChange(e, index, fieldName) {
    setTableData((prevTableData) => {
      const updatedTableData = [...prevTableData];
      if (e === null) {
        updatedTableData[index][fieldName] = null;
      } else {
        updatedTableData[index][fieldName] = e ? e.value : null;
      }
      if (fieldName.startsWith("group")) {
        let x = fieldName.split("_").pop();
        x = 1 + parseInt(x);
        for (x; x <= 5; x++) {
          updatedTableData[index]["group_" + x] = null;
        }
        updatedTableData[index]["position"] = null;
      }
      return updatedTableData;
    });
  }

  // Function help change option select
  function handleTypeChange(e, index) {
    setTableData((prevTableData) => {
      const updatedTableData = [...prevTableData];
      try {
        updatedTableData[index]["type"] = parseInt(e.target.value);
      } catch {
        updatedTableData[index]["type"] = 1;
      }
      return updatedTableData;
    });
  }

  // Function help change option select
  function handleChangeUser(e, index) {
    setTableData((prevTableData) => {
      if (e === null) {
        const updatedTableData = [...prevTableData];
        updatedTableData[index]["user_id"] = 0;
        updatedTableData[index]["email"] = "";
        return updatedTableData;
      }
      const updatedTableData = [...prevTableData];
      updatedTableData[index]["user_id"] = e.value;
      let user = users.find((u) => u.value === e.value);
      updatedTableData[index]["email"] = user.email;
      return updatedTableData;
    });
  }

  // Handle update element
  const handleUpdateTemplates = (action, index, e) => {
    var templates = [...workTemplates];
    if (action === "add") {
      if (templates.length >= 9) {
        setButtonDisable(true);
      }
      if (templates.length === 0) {
        templates.push(null);
      }
      templates.push(null);
    }
    if (action === "remove") {
      // const indexRemove = templates.findIndex(t => t.value === index);
      templates.splice(index, 1);
      if (buttonDisable) {
        setButtonDisable(false);
      }
    }
    if (action === "update") {
      templates[index] = e;
    }
    setWorkTemplates(templates);
  };

  // Handle update row table
  const handleUpdateRowTable = (action, index) => {
    if (tableData.length >= 9 && action === "add") {
      setButtonState(true);
    }
    var idRow = 0;
    if (tableData.length !== 0) {
      idRow = tableData.length + 1;
    }
    const newRow = {
      id: idRow,
      type: 2,
      group_1: null,
      group_2: null,
      group_3: null,
      group_4: null,
      group_5: null,
      position: null,
      user_id: null,
      email: "",
      can_reject: false,
      can_approve: false,
      notification_page: tableData.length === 0,
      notification_email: false,
    };
    const data = [...tableData];
    if (action === "add") {
      data.push(newRow);
    } else {
      data.splice(index, 1);
      if (buttonState) {
        setButtonState(false);
      }
      if (data.length) {
        data[0]["notification_page"] = true;
      }
    }
    setTableData(data);
  };

  // Function handle back
  function handleBack() {
    window.location.href = APPROVAL_SETTING;
  }

  // Function handle update data
  function handleSubmit() {
    let data = {
      id: /^\d+$/.test(workFollowId) ? workFollowId : null,
      name: workFollowName,
      frequency: frequency,
      templates: workTemplates.map((t) => (t ? { id: t.value } : { id: 0 })),
      sequences: tableData,
    };
    setProcessing(true);
    submitWorkFlow(data, workFollowId)
      .then((response) => {
        setErrors({});
        setFlash("approve-setting", response.message);
        let url = routes.APPROVAL_SETTING + "/" + response.data.id;
        const data = {name: APPROVAL_SETTING_DETAIL_PAGE, url: url}
        setFlash(PREVIOUS_PAGE, JSON.stringify(data));
        window.location.href = url;
      })
      .catch((e) => {
        errorStatusHandle(e);
        if (e.status === 400) {
          dispatch(setAlertErrorWorkflowDetails(e.data));
          setErrors(e.data.errors);
        }
      })
      .finally(() => {
        setProcessing(false);
      });
  }

  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <PageTitle title={breadcrumb[breadcrumb.length - 1]?.menu} />
      <RedirectAlert />
      <PageAlert />
      <ButtonDPad />
      <div className="">
        <div className="w-[1200px] px-4 pt-3 pb-3 xl:px-6 xl:pt-5 xl:pb-5 rounded-lg bg-white border border-tenken-gray-300">
          <p className="font-light">承認設定に関する情報を入力してください。</p>
          <FormGroup className="mt-4">
            <Label className="w-[280px] xl:w-[360px]">
              承認設定名を入力してください
            </Label>
            <FormGroupVerticalInput
              error={getInputErrorMessage(errors, "name")}
            >
              <TextInput
                maxLength={40}
                autoFocus
                type="text"
                className="approval__information--items xl:w-[480px] w-[440px]"
                placeholder="入力プレースホルダー"
                value={workFollowName}
                onChange={(e) => setWorkFollowName(e.target.value)}
                hasError={hasErrorInput(errors, "name")}
              />
            </FormGroupVerticalInput>
          </FormGroup>
          <FormGroup
            labelWidth="w-[280px] xl:w-[360px]"
            inputWidth="xl:w-[480px] w-[440px]"
          >
            <Label className="w-[280px] xl:w-[360px] !-mt-[2px]">
              承認設定の頻度を選択してください
            </Label>
            <FormGroupInput error={getInputErrorMessage(errors, "frequency")}>
              <div className="flex space-x-9">
                <RadioInput
                  name="type_of_approval"
                  id="daily"
                  onChange={handleChangeRadio}
                  value={1}
                  checked={frequency === 1}
                  label="日常承認"
                />
                <RadioInput
                  name="type_of_approval"
                  id="weekly"
                  onChange={handleChangeRadio}
                  value={2}
                  checked={frequency === 2}
                  label="週次承認"
                />
                <RadioInput
                  name="type_of_approval"
                  id="monthly"
                  onChange={handleChangeRadio}
                  value={3}
                  checked={frequency === 3}
                  label="月度承認"
                />
              </div>
            </FormGroupInput>
          </FormGroup>
          {workTemplates.length === 0 ? (
            <FormGroup>
              <Label className="w-[280px] xl:w-[360px]">
                点検テンプレートを選択してください
              </Label>
              <FormGroupVerticalInput
                error={getInputErrorMessage(errors, "template_" + 0)}
              >
                <Select2
                  className="approval__information--items xl:w-[480px] w-[440px]"
                  classNamePrefix="react-select"
                  options={templates}
                  placeholder="点検テンプレート1"
                  onChange={(e) => handleUpdateTemplates("update", 0, e)}
                  hasError={hasErrorInput(errors, "template_" + 0)}
                />
              </FormGroupVerticalInput>
            </FormGroup>
          ) : (
            <FormGroup>
              <Label className="w-[280px] xl:w-[360px]">
                点検テンプレートを選択してください
              </Label>
              <FormGroupVerticalInput
                error={getInputErrorMessage(errors, "template_" + 0)}
              >
                <Select2
                  className="approval__information--items xl:w-[480px] w-[440px]"
                  classNamePrefix="react-select"
                  value={workTemplates[0]}
                  options={templates}
                  placeholder="点検テンプレート1"
                  onChange={(e) => handleUpdateTemplates("update", 0, e)}
                  hasError={hasErrorInput(errors, "template_" + 0)}
                />
              </FormGroupVerticalInput>
            </FormGroup>
          )}
          {workTemplates.slice(1).map((template, count) => (
            <FormGroup labelWidth="w-[140px]" key={count}>
              <label className="approval__information--label"></label>
              <FormGroupVerticalInput
                error={getInputErrorMessage(errors, "template_" + (count + 1))}
              >
                <Select2
                  className="approval__information--items xl:w-[480px] w-[440px]"
                  classNamePrefix="react-select"
                  options={templates}
                  value={template}
                  placeholder={`点検テンプレート${count + 2}`}
                  onChange={(e) =>
                    handleUpdateTemplates("update", count + 1, e)
                  }
                  hasError={hasErrorInput(errors, "template_" + (count + 1))}
                />
              </FormGroupVerticalInput>
              <div className="ml-[16px]">
                <ButtonDelete
                  className="ml-4"
                  onClick={(e) => handleUpdateTemplates("remove", count + 1, e)}
                />
              </div>
            </FormGroup>
          ))}

          <div className="approval__information--group-add">
            <label className="approval__information--label"></label>
            <ButtonAdd
              className="w-[180px]"
              onClick={() => handleUpdateTemplates("add")}
              disabled={buttonDisable}
            >
              点検テンプレート
            </ButtonAdd>
          </div>
        </div>
        {tableData?.length > 0 && (
          <div className="w-fit pr-6">
            <div className="border border-tenken-gray-300 rounded-lg mt-4 w-fit">
              <Table striped>
                <Table.Head>
                  <Table.HeadCell className="whitespace-nowrap">
                    回覧順
                  </Table.HeadCell>
                  <Table.HeadCell className="whitespace-nowrap">
                    種類
                  </Table.HeadCell>
                  <Table.HeadCell className="whitespace-nowrap">
                    設定
                  </Table.HeadCell>
                  <Table.HeadCell className="whitespace-nowrap">
                    登録可能な判定結果
                  </Table.HeadCell>
                  <Table.HeadCell className="whitespace-nowrap">
                    通知先
                  </Table.HeadCell>
                  <Table.HeadCell></Table.HeadCell>
                </Table.Head>
                <Table.Body>
                  {tableData.map((row, index) => (
                    <Table.Row key={index}>
                      <Table.Cell className="text-center">
                        {index + 1}
                      </Table.Cell>
                      <Table.Cell className="">
                        <SelectInput
                          options={typeOptions}
                          value={row.type || ""}
                          className="md:w-[140px] xl:w-[160px] 2xl:w-[180px] inline-block"
                          name="type"
                          onChange={(e) => handleTypeChange(e, index)}
                        />
                      </Table.Cell>
                      {row.type === 2 ? (
                        <Table.Cell className="flex">
                          {ArrayUtils.range(1, 5).map(
                            (i) =>
                              groupSettings[`group_${i}`]?.active && (
                                <Select2
                                  options={groupsOptions[index]?.[i] ?? []}
                                  isClearable={false}
                                  hasError={errors[`group_${i}_${index}`]}
                                  value={
                                    groupTree?.findNode(row[`group_${i}`])
                                      ?.data ?? { value: null, label: "[ALL]" }
                                  }
                                  classNamePrefix="react-select"
                                  className={"approval__table-select mr-2 "}
                                  placeholder={groupSettings[`group_${i}`]?.name}
                                  onChange={(e) =>
                                    handleSelectChange(e, index, `group_${i}`)
                                  }
                                  maxLength="30"
                                />
                              )
                          )}
                          <Select2
                            options={SelectUtils.getPositionOptions(
                              departments,
                              row
                            )}
                            hasError={errors[`position_${index}`]}
                            isClearable={true}
                            className={"approval__table-select mr-2 "}
                            classNamePrefix="react-select"
                            value={SelectUtils.getSelectedValue(
                              SelectUtils.getPositionOptions(departments, row),
                              row.position
                            )}
                            placeholder="職位"
                            onChange={(e) =>
                              handleSelectChange(e, index, "position")
                            }
                            maxLength="50"
                          />
                        </Table.Cell>
                      ) : (
                        <Table.Cell className="whitespace-nowrap flex items-center">
                          <Select2
                            options={users}
                            classNamePrefix="react-select"
                            hasError={errors[`user_id_${index}`]}
                            placeholder="ユーザーを選択してください。"
                            value={SelectUtils.getSelectedValue(
                              users,
                              row.user_id
                            )}
                            className="approval__table-select-user"
                            onChange={(e) => handleChangeUser(e, index)}
                            maxLength="20"
                          />
                          <div className="max-w-[440px] truncate">
                            <span
                              className="approval__table-label"
                              title={row.email}
                            >
                              {row.email}
                            </span>
                          </div>
                        </Table.Cell>
                      )}
                      <Table.Cell>
                        <div className="flex items-center 2xl:gap-[28px] xl:gap-[24px] md:gap-[20px]">
                          <CheckboxInput
                            value="approval"
                            name={`judgment_results_${index}[]`}
                            id={`judgment_results_approval_${index}`}
                            classInput="xl:w-7 xl:h-7 w-5 h-5"
                            checked={true}
                            disabled
                            label="承認"
                          ></CheckboxInput>
                          <CheckboxInput
                            value="reject"
                            name={`judgment_results_${index}[]`}
                            id={`judgment_results_remand_${index}`}
                            checked={row.can_reject}
                            onChange={(e) => {
                              handleChangeInputCheckbox(e, index, `can_reject`);
                            }}
                            label="差し戻し"
                          />
                        </div>
                      </Table.Cell>
                      <Table.Cell>
                        <div className="flex items-center 2xl:gap-[28px] xl:gap-[24px] md:gap-[20px]">
                          <CheckboxInput
                            value="page"
                            name={`notification_page_${index}[]`}
                            id={`notification_page_${index}`}
                            checked={row.notification_page}
                            onChange={(e) => {
                              handleChangeInputCheckbox(
                                e,
                                index,
                                `notification_page`
                              );
                            }}
                            label="通知ページ"
                          />
                          <CheckboxInput
                            value="email"
                            name={`notification_email${index}[]`}
                            id={`notification_email_${index}`}
                            checked={row.notification_email}
                            onChange={(e) => {
                              handleChangeInputCheckbox(
                                e,
                                index,
                                `notification_email`
                              );
                            }}
                            label="メール"
                          />
                        </div>
                      </Table.Cell>
                      <Table.Cell>
                        <ButtonTableDelete
                          type="button"
                          onClick={() => handleUpdateRowTable("remove", index)}
                        />
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          </div>
        )}

        <div className="md:mt-3 xl:mt-6">
          <ButtonAdd
            className="w-[180px]"
            onClick={() => handleUpdateRowTable("add")}
            disabled={buttonState}
          >
            回覧順を追加
          </ButtonAdd>
        </div>

        <div className="machine-update__btn--group">
          <ButtonBack
            onClick={handleBack}
            className="mr-[60px] xl:mr-[200px]"
          />
          {workFollowId === "new" ? (
            <ButtonAdd
              onClick={handleSubmit}
              isProcessing={processing}
              className="machine-update__btn--edit"
            >
              新規追加
            </ButtonAdd>
          ) : (
            <ButtonEdit
              isProcessing={processing}
              onClick={handleSubmit}
              className="machine-update__btn--edit"
            >
              更新
            </ButtonEdit>
          )}
        </div>
      </div>
    </BackendLayout>
  );
}
